export default "__VITE_ASSET__9WNv$TJA5zw55OKnpWjjdQ__"